module.exports = __webpack_public_path__ + "static/media/badge_ptrnB.dd3ad5eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge_ptrnB.png
// module id = 1620
// module chunks = 1